<div class="card">
    <div class="card-body">
        <div class="row">
            <div class="col-12">
                <h4 class="fs-6">Elige entre: {{policyDetail.label}} para ver el detalle</h4>
                <hr>
                <div class="form-group">
                    <input (keyup)="filterDetail()" [(ngModel)]="searchFilter" [placeholder]="policyDetail.searchLabel || ''" class="form-control form-control-sm border focus-ring focus-ring-dark" />
                </div>
                <div class="d-flex bg-light flex-column gap-2 p-2 mt-3 rounded-4">
                @for (policy of filteredPolicies; track $index) {
                    <div (click)="onPolicySelected(policy, $index)" [ngClass]="{ 'policy-selected': $index === indexSelected}" class="card border p-3 selectable-policy-item">
                        <div [innerHTML]="policy.cardContent"></div>
                        @if (policyDetail.downloadCarnet) {
                          <div class="mt-2">
                            <div ngbDropdown class="d-inline-block" (click)="$event.stopPropagation()">
                              <button ngbDropdownToggle class="btn btn-sm btn-outline-dark">Descargar marbete</button>
                              <div ngbDropdownMenu>
                                <button ngbDropdownItem (click)="$event.stopPropagation(); downloadCarnet(CarnetImageType.Front, policy.vehicleNumber)">Vista frontal</button>
                                <button ngbDropdownItem (click)="$event.stopPropagation(); downloadCarnet(CarnetImageType.Back, policy.vehicleNumber)">Vista posterior</button>
                              </div>
                            </div>
                          </div>
                        }
                    </div>
                } @empty {
                    <div class="d-flex justify-content-center p-2">{{policyDetail.emptyLabel}}</div>
                }
                </div>
            </div>
        </div>
    </div>
</div>

<app-coverage-modal #coverageModal></app-coverage-modal>
<app-contact-modal #contactModal></app-contact-modal>
<app-passanger-modal #passangerModal></app-passanger-modal>

<ng-template #content let-offcanvas>
    <div class="offcanvas-header d-flex w-100 flex-column align-content-start gap-2">
        <button (click)="offcanvas.dismiss('Cross click')" aria-label="Close" class="btn-close focus-ring focus-ring-dark" type="button"></button>
        <figure class="mb-2">
            <img alt="" class="object-fit-contain" height="22px" src="../../../assets/img/nav/la-colonial-de-seguros-logo.svg" width="144px">
        </figure>
        <h4 class="offcanvas-title fs-5 text-colonial" id="offcanvas-basic-title">{{policyDetail.detailLabel}}</h4>
    </div>
    <div class="offcanvas-body bg-light">
        <div class="card rounded-3 d-flex flex-column gap-2 my-3 p-3" style="border: 1px solid #d0d0d0 !important;">
            @for (item of policySelected.infoLabels; track $index) {
            <div class="d-flex flex-column lign-items-center gap-0 small">
                <span class="fw-semibold">{{item.label}}</span>
                <span>{{item.value}}</span>
            </div>
            }
        </div>
        @if (policySelected.contactInfo || policySelected.passangers) {
        <div class="card border-dark my-3 p-3" style="border: 1px solid #d0d0d0 !important;">
            <h4 class="fs-6 text-colonial fw-semibold mb-2">Información del plan</h4>
            @if (policySelected.contactInfo) {
            <button (click)="showPassanger()" class="d-flex align-items-center gap-3 mb-1 btn btn-sm p-2 fw-semibold d-flex border justify-content-between rounded-3">
                <span>Pasajeros asegurados</span>
                <span class="material-symbols-outlined">keyboard_arrow_right</span>
            </button>
            }
            @if (policySelected.contactInfo) {
            <button (click)="showContact()" class="d-flex align-items-center gap-3 mb-1 btn btn-sm p-2 fw-semibold d-flex border justify-content-between rounded-3">
                <span>Información de contacto</span>
                <span class="material-symbols-outlined">keyboard_arrow_right</span>
            </button>
            }
        </div>
        }

        <div class="border-top py-3 d-flex flex-column gap-3 ottom-0 border-0">
            <div class="d-flex flex-column gap-2">
                @if(policySelected && policySelected.coverages && policySelected.coverages.length){
                    <button (click)="showCoverage()" class="btn rounded-3 fw-semibold btn-ourline-light text-colonial border">Ver cobertura</button>
                }
            </div>
            @if(policyDetail.downloadCarnet){
            <div class="label-download d-flex gap-2">
                <span class="material-symbols-outlined">
                    download
                </span>
                Descarga tu marbete
            </div>
            }
            <div class="d-flex flex-column flex-sm-row gap-2">
                @if(policyDetail.downloadCarnet){
                    <button (click)="downloadCarnet(CarnetImageType.Front)" class="btn rounded-3 w-100 btn-dark bg-cololinal border-0">Vista frontal</button>
                    <button (click)="downloadCarnet(CarnetImageType.Back)" class="btn rounded-3 w-100 btn-dark bg-cololinal border-0">Vista posterior</button>
                }
            </div>
        </div>
    </div>
</ng-template>
